
export function qqMap (key) {
  return new Promise(function (resolve, reject) {
    resolve(window.qq)
  })
}



// WEBPACK FOOTER //
// ./src/utils/qqMap.js